import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { memo } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { FormikProps } from 'formik';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FiltersFormCirculationArea } from 'system/pages/toponymy/circulation-area/list/types';
import PmiTextField from 'shell/components/shared/text-field';

interface FiltersCirculationAreaProps {
  filterCirculationAreaForm: FormikProps<FiltersFormCirculationArea>;
  setOpen: (value: boolean) => void;
  open?: boolean;
}

const FiltersCirculationAreaComponent = ({
  filterCirculationAreaForm,
  setOpen,
  open,
}: FiltersCirculationAreaProps): React.ReactElement => {
  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-circulationarea-content"
        id="panel-circulationarea-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterCirculationAreaForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={2}>
              <PmiTextField
                aria-label="Codice"
                label="Codice"
                id="code"
                name="code"
                fullWidth
                type="text"
                variant="outlined"
                value={filterCirculationAreaForm.values.code}
                onChange={filterCirculationAreaForm.handleChange}
                error={
                  filterCirculationAreaForm.touched.code &&
                  Boolean(filterCirculationAreaForm.errors.code)
                }
                helperText={filterCirculationAreaForm.errors.code}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <PmiTextField
                aria-label="Nome"
                label="Nome"
                id="name"
                name="name"
                fullWidth
                type="text"
                variant="outlined"
                value={filterCirculationAreaForm.values.name}
                onChange={filterCirculationAreaForm.handleChange}
                error={
                  filterCirculationAreaForm.touched.name &&
                  Boolean(filterCirculationAreaForm.errors.name)
                }
                helperText={filterCirculationAreaForm.errors.name}
              />
            </Grid>
            <Grid item xs>
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filterCirculationAreaForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersCirculationAreaComponent.displayName = 'Filters Circulation Area component';

const FiltersCirculationArea = memo(FiltersCirculationAreaComponent);

export default FiltersCirculationArea;
